import { AssessmentMode } from "../types";
import {ActionComponent,ActionButtonRow, FrameBody,Title} from "@npd-ng/adp-benchmark";
import connected from '../assets/connected.svg';
import wifi from '../assets/school_wifi.svg';
import { actions } from "../state";
import { Content } from "../types/Content";
import { Container } from "react-bootstrap";
import { useStateContext } from "../hooks/useStateContext";

import { useIPCBridge } from "../hooks/useIPCBridge";
import { useDedupEffect } from "../util/useDedupEffect";
import { useDeviceValidationService } from "../hooks/useDeviceValidationService";

const logPrefix = "[ADPClient][ModeSelectionView]";
export default function ModeSelectionView(){
    const { state, dispatch } = useStateContext();
    const {performSystemChecks} = useDeviceValidationService(dispatch,state);
 
    const {sendDeliveryMode} = useIPCBridge(dispatch,state);
    console.log(logPrefix, "session state",state.sessionState);
    const content= state.staticContent as Content;
    const modeSelectionActions: ActionComponent[] =[]; 
    const assessmentModeStaticContent =  state.staticContent?.assessmentLaunchModes;
    const modeSelectionAction = async (selectedMode: AssessmentMode)=>{
        //support ncs mode over internet - pass url q. param - e.g lcs_api_url=192.168.1.171:4011
        dispatch(actions.createSetAssessmentModeAction(selectedMode));
        sendDeliveryMode(selectedMode); 
    }
    const ncsLaunchMode:ActionComponent = {
        iconSrc : connected,
        label : assessmentModeStaticContent?.ncs.title as string,
        actionDescription : assessmentModeStaticContent?.ncs.description as string,
        action: ()=>{modeSelectionAction("ncs")}
    };
    const onlineLaunchMode:ActionComponent = {
        iconSrc : wifi,
        label : assessmentModeStaticContent?.online.title as string,
        actionDescription : assessmentModeStaticContent?.online.description as string,
        action: ()=>{modeSelectionAction("online")}
    } 
    state.appState.configuration?.assessmentLaunchModes?.forEach((mode)=>{
    const action: ActionComponent = mode === "ncs" ? ncsLaunchMode :  onlineLaunchMode
    modeSelectionActions.push(action);
   })
    useDedupEffect(()=>{
        //skip mode selection for SBE devices - 2024 SBE POC req
        if(state.deviceState.deviceType === "SBE"){
            modeSelectionAction("online");
        }
        performSystemChecks();
    },[])
    return (
         <>  
          {state.deviceState.deviceType === "NPE" &&
           <FrameBody>
           <Container className="titleWidth">
                 <Title  content={content?.mainText}/>
            </Container>
           <ActionButtonRow actions={modeSelectionActions} />
           </FrameBody>
            }
        </>
   
    )
}